/* =========================================================
   Squishy Pop – mini-jeux
   ========================================================= */
(function () {
  'use strict';
  function L(k, d) { var s = window.theme && window.theme.strings; return (s && s[k]) || d; }
  function fx() { return window.SquishyFX || { burst: function () {}, squish: function () {} }; }
  function store(key, val) {
    try { if (val === undefined) return localStorage.getItem(key); localStorage.setItem(key, val); } catch (e) { return null; }
  }
  function center(el) { var r = el.getBoundingClientRect(); return { x: r.left + r.width / 2, y: r.top + r.height / 2 }; }
  function bigBurst(el) {
    var c = center(el);
    [0, 140, 280].forEach(function (d) { setTimeout(function () { fx().burst(c.x + (Math.random() - .5) * 80, c.y + (Math.random() - .5) * 60, 18); }, d); });
  }

  /* ---------- Copier le code ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-copy]');
    if (!b) return;
    var code = b.getAttribute('data-copy');
    var done = function () { var t = b.textContent; b.textContent = L('copied', 'Copié ✓'); setTimeout(function () { b.textContent = t; }, 1800); };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(function () { selectCode(b); });
    } else selectCode(b);
  });
  function selectCode(b) {
    var c = b.parentElement.querySelector('code');
    if (!c) return;
    var r = document.createRange(); r.selectNodeContents(c);
    var s = window.getSelection(); s.removeAllRanges(); s.addRange(r);
  }

  /* ---------- Défi : presse le squishy ---------- */
  function initPress(game) {
    if (game.dataset.ready) return; game.dataset.ready = '1';
    var goal = parseInt(game.dataset.goal, 10) || 15;
    var key = 'sp-' + game.dataset.key;
    var btn = game.querySelector('[data-press-target]');
    var bar = game.querySelector('[data-press-bar]');
    var count = game.querySelector('[data-press-count]');
    var live = game.querySelector('[data-press-live]');
    var label = game.querySelector('[data-press-label]');
    var reward = game.querySelector('[data-press-reward]');
    var n = 0;
    var LABELS = [[0, L('press0', '👆 Appuie !')], [0.3, L('press1', 'Continue 💪')], [0.6, L('press2', 'Encore un peu…')], [0.85, L('press3', 'Presque !! 🔥')]];
    function render() {
      var p = Math.min(1, n / goal);
      bar.style.width = (p * 100) + '%';
      count.textContent = Math.min(n, goal);
      for (var i = LABELS.length - 1; i >= 0; i--) { if (p >= LABELS[i][0]) { label.textContent = LABELS[i][1]; break; } }
    }
    function win(animate) {
      n = goal; render();
      btn.classList.add('is-done'); btn.setAttribute('aria-disabled', 'true');
      label.textContent = L('won', 'Défi réussi ! 🎉');
      reward.hidden = false;
      live.textContent = L('won_live', 'Défi réussi, ta récompense est affichée.');
      if (animate) bigBurst(btn);
      store(key, 'won');
    }
    if (store(key) === 'won') { win(false); return; }
    btn.addEventListener('click', function (e) {
      if (n >= goal) return;
      n++; render();
      if (e.detail === 0) fx().squish(btn.querySelector('[data-squish]'));
      // petit « +1 » qui s'envole
      var x = e.clientX || center(btn).x, y = e.clientY || center(btn).y;
      if (document.body.animate) {
        var plus = document.createElement('span');
        plus.className = 'press-plus'; plus.textContent = '+1';
        document.body.appendChild(plus);
        plus.animate([
          { transform: 'translate(' + x + 'px,' + y + 'px) scale(.6)', opacity: 1 },
          { transform: 'translate(' + (x + (Math.random() - .5) * 40) + 'px,' + (y - 70) + 'px) scale(1.1)', opacity: 0 }
        ], { duration: 700, easing: 'ease-out' }).onfinish = function () { plus.remove(); };
      }
      if (n % 5 === 0 && n < goal) fx().burst(x, y, 6);
      if (n >= goal) win(true);
    });
    render();
  }

  /* ---------- Quiz ---------- */
  function initQuiz(quiz) {
    if (quiz.dataset.ready) return; quiz.dataset.ready = '1';
    var steps = quiz.querySelectorAll('[data-quiz-step]');
    var dots = quiz.querySelectorAll('.quiz__dots span');
    var results = quiz.querySelectorAll('[data-quiz-result]');
    var score = [0, 0, 0, 0], step = 0;
    function show(i) {
      steps.forEach(function (s, k) { s.hidden = k !== i; });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k <= i); });
    }
    quiz.addEventListener('click', function (e) {
      var a = e.target.closest('[data-quiz-answer]');
      if (a) {
        score[+a.dataset.quizAnswer]++;
        step++;
        if (step < steps.length) { show(step); var next = steps[step].querySelector('button'); if (next) next.focus(); return; }
        steps.forEach(function (s) { s.hidden = true; });
        var best = 1; for (var r = 2; r <= 3; r++) if (score[r] > score[best]) best = r;
        results.forEach(function (res) { res.hidden = +res.dataset.quizResult !== best; });
        var shown = quiz.querySelector('[data-quiz-result="' + best + '"]');
        quiz.querySelector('.quiz__dots').hidden = true;
        bigBurst(shown.querySelector('.quiz__result-art') || shown);
        var link = shown.querySelector('a'); if (link) link.focus();
        return;
      }
      if (e.target.closest('[data-quiz-restart]')) {
        score = [0, 0, 0, 0]; step = 0;
        results.forEach(function (res) { res.hidden = true; });
        quiz.querySelector('.quiz__dots').hidden = false;
        show(0); steps[0].querySelector('button').focus();
      }
    });
  }

  /* ---------- Boîte mystère ---------- */
  function initMystery(box) {
    if (box.dataset.ready) return; box.dataset.ready = '1';
    var gift = box.querySelector('[data-mystery-box]');
    var taps = box.querySelector('[data-mystery-taps]');
    var reward = box.querySelector('[data-mystery-reward]');
    var n = 0, NEED = 3;
    var MSG = [L('box0', '👆 Tape 3 fois pour l\'ouvrir'), L('box1', 'Ça bouge… 👀'), L('box2', 'Encore une fois !')];
    gift.addEventListener('click', function () {
      if (gift.classList.contains('is-open')) return;
      n++;
      gift.classList.remove('is-shake'); void gift.offsetWidth; gift.classList.add('is-shake');
      if (n < NEED) { taps.textContent = MSG[n]; return; }
      setTimeout(function () {
        gift.classList.add('is-open');
        gift.setAttribute('aria-label', L('box_open', 'Boîte ouverte'));
        taps.hidden = true;
        reward.hidden = false;
        bigBurst(gift);
      }, 420);
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-press-game]').forEach(initPress);
    (root || document).querySelectorAll('[data-quiz]').forEach(initQuiz);
    (root || document).querySelectorAll('[data-mystery]').forEach(initMystery);
  }
  init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
